<template>
    <div id="site-details-page">
        <ToolbarComponent v-if="$route.name === 'consumption_tracking'" :title="site.address_name" />
        <ToolbarBackButtonComponent v-else :subtitle="subtitle" :title="site.address_name" icon_subtitle="mdi-map-marker-outline" />

        <ProductReportWidgetComponent :id_domicile="parseInt($route.params.id)" />
    </div>
</template>

<script>
import ToolbarBackButtonComponent from '@/components/global/ToolbarBackButtonComponent'
import ToolbarComponent from '@/components/global/ToolbarComponent'
import ProductReportWidgetComponent from '@/components/site/widget/ProductReportWidgetComponent.vue'

export default {
    name: 'SiteDetailsPage',
    components: {
        ToolbarBackButtonComponent,
        ToolbarComponent,
        ProductReportWidgetComponent,
    },
    computed: {
        site() {
            return (
                this.$store.getters['domiciles/domiciles'].find(
                    (domicile) => domicile.id_domicile === parseInt(this.$route.params.id)
                ) ?? {}
            )
        },

        subtitle() {
            return `${this.site.address}, ${this.site.postal_code} ${this.site.city}, ${this.site.country}`
        },
    },
}
</script>
